import React, { Component } from 'react';

import { List, Segment } from 'semantic-ui-react';

import PatientItem from './Items/PatientItem';
import Pagination from '../../utils/Pagination';

const options = [
  { key: '1', text: '10 por página', value: 10 },
  { key: '2', text: '20 por página', value: 20 },
  { key: '3', text: '50 por página', value: 50 },
  { key: '4', text: '100 por página', value: 100 }
];

class PatientList extends Component {
  state = { paginatedItems: [], itemsPerPage: 10 };

  onChangePage = e => {
    this.setState({
      paginatedItems: e
    });
  };

  render() {
    const { patientsList } = this.props;
    const { paginatedItems, itemsPerPage } = this.state;
    let patient_item = [];
    patient_item = paginatedItems.map((patient, index) => (
      <PatientItem
        patient={patient}
        key={index}
        showPatientOrdersList={this.props.showPatientOrdersList}
        practitioner={this.props.practitioner}
        filterRange={this.props.filterRange}
      />
    ));

    return (
      <Segment className='listAlign'>
        <List selection verticalAlign='middle' divided size='small'>
          {patient_item}
        </List>
        <Pagination
          items={patientsList}
          itemsPerPage={itemsPerPage}
          onChangePage={this.onChangePage}
          options={options}
        />
      </Segment>
    );
  }
}

export default PatientList;
